import "./AgentsDetails.css";
import React, { Fragment, useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getDownloadURL, getStorage, listAll, ref } from "firebase/storage";
import { TabComponent } from "@syncfusion/ej2-react-navigations";
import NoDataFoundIcon from "../../assets/icons/new-icons/noDataFoundWeb.svg";
import DealsCard from "../../components/Deals/DealsCard/DealsCard";
import NoDataFound from "../../components/Common/NoDataFound/NoDataFound";

import noDataMobileIcon from "../../assets/icons/new-icons/noDataMobile.svg";
// MUI Start
import { DataGrid } from "@mui/x-data-grid";
// MUI End
import ConfirmationModal from "../../components/Common/ConfirmationModal/ConfirmationModal";

// Common Components Start
import TableMenu from "../../components/Common/TableMenu/TableMenu";
import AgentProperties from "../../components/User/Agents/AgentProperties/AgentProperties";
// Common Components End
import activeIconWeb from "../../assets/icons/new-icons/active_web.svg";
import inActiveIconWeb from "../../assets/icons/new-icons/inactive_web.svg";
// import activeIconMobile from "../../assets/icons/new-icons/active_mobile.svg";
import inActiveIconMobile from "../../assets/icons/new-icons/inactive_mobile.svg";
import deleteIconMobile from "../../assets/icons/new-icons/delete_mobile.svg";
import deleteIconWeb from "../../assets/icons/new-icons/delete_web.svg";
import invite from "../../assets/icons/new-icons/inviteWeb.svg";
import inviteIconWeb from "../../assets/icons/new-icons/inviteWebIcon.svg";
import inviteIconMobile from "../../assets/icons/new-icons/invite.svg";

// Controllers Start
import GetAgentProperties from "../../controllers/agents/GetAgentProperties";
import GetProperty from "../../controllers/properties/getProperty";
import AgentVisits from "../../controllers/visits/AgentVisits";
import ContentLoader from "../../components/Common/ContentLoader/ContentLoader";
import GetAgentDealController from "../../controllers/Enquiries/GetAgentDealController";
import AgentSingleDealContent from "../../components/Deals/AgentSingleDealContent/AgentSingleDealContent";
import getSettings from "../../controllers/settings/getSettings";
import GetTotalPropertiesForAgent from "../../controllers/agents/GetTotalPropertiesForAgent";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../firebase";
import { getLocalStorageItem } from "../../controllers/localStorage/getLocalStorage";
// Controllers End
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../helpers/stringAvatar";
import { toast, ToastContainer } from "react-toastify";
import UpdateAgentEmailFlag from "../../controllers/agents/UpdateAgentEmailFlag";
import UpdateAgentStatusToInActive from "../../controllers/agents/UpdateAgentStatusToInActive";
import UpdateAgentStatusToActive from "../../controllers/agents/UpdateAgentStatusToActive";
import DeleteAgent from "../../controllers/agents/DeleteAgent";
import UserListCardDetail from "../../components/UserListCardDetail/UserListCardDetail";
import PropertiesContent from "../Properties/PropertiesContent/PropertiesContent";
import SmallScreensLogVisitsComponent from "../../components/Common/SmallScreensLogVisitsComponent/SmallScreensLogVisitsComponent";
// Custom Style If There Are No Agent Visits Data In Agent Visits DataGrid Table Start

const AgentsDetails = () => {
  let location = useLocation();
  const agentURLId = location.pathname.split("/").pop();
  // useStates Start
  const [agentDetails, setAgentDetails] = useState(null);
  const [agentVisits, setAgentVisits] = useState(null);
  const [agentProperty, setAgentProperty] = useState([]);
  const [RequestingAgents, setRequestingAgents] = useState(true);
  const [RequestingPropertiers, setRequestingPropertiers] = useState(true);
  const [refreshAgentStatus, setRefreshAgentStatus] = useState(false);

  // useStates End

  // Currency Settings UseEffect Start
  const [CurrencySettings, setCurrencySettings] = useState({});
  useEffect(() => {
    async function fetchData() {
      const settings = await getSettings();
      setCurrencySettings(settings);
    }
    fetchData();
  }, [agentURLId]);
  // Currency Settings UseEffect End
  useEffect(() => {
    let agentId = location.pathname.split("/").pop();

    let agent = {};
    let unsubscribe = onSnapshot(
      doc(db, "clients", getLocalStorageItem("bid"), "agents", agentId),
      (doc) => {
        agent = { id: doc.id, ...doc.data() };
        setAgentDetails(agent);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [agentURLId]);

  // Agent Details useEffect Start
  useEffect(() => {
    async function fetchData() {
      setRequestingPropertiers(true);
      let agentID = location.pathname.split("/").pop();

      const agentProperties = await GetAgentProperties(agentID);
      let agentPropertiesIds = [];

      for (let index = 0; index < agentProperties.length; index++) {
        const { id } = agentProperties[index];
        const { items } = await listAll(ref(getStorage(), `/properties/${id}`));
        let thumbnail;
        if (items.length !== 0) thumbnail = await getDownloadURL(items[0]);
        else
          thumbnail =
            "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general_images%2FloadingImg.gif?alt=media&token=9b58ee8f-4f7a-4757-8705-d004f7d5d3b1";
        agentProperties[index] = {
          ...agentProperties[index],
          thumbnail,
        };
      }

      let getAgentDealProperties = [];

      const agentDeals = await GetAgentDealController(agentID);

      if (agentDeals.length === 0) {
        getAgentDealProperties = [];
      } else {
        agentPropertiesIds = agentProperties.map((agentProperty) => {
          return agentProperty.id;
        });

        let agentDealAfterRemoveDuplicates = agentDeals.filter(
          (deal) => !agentPropertiesIds.includes(deal.property)
        );

        let agentDealPropertyIds = agentDealAfterRemoveDuplicates.map(
          (deal) => {
            return deal.property;
          }
        );

        getAgentDealProperties =
          (await GetTotalPropertiesForAgent(agentDealPropertyIds)) || [];

        for (let index = 0; index < getAgentDealProperties.length; index++) {
          const { id } = getAgentDealProperties[index];
          const { items } = await listAll(
            ref(getStorage(), `/properties/${id}`)
          );
          let thumbnail;
          if (items.length !== 0) thumbnail = await getDownloadURL(items[0]);
          else
            thumbnail =
              "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general_images%2Fproperty-avatar.jpg?alt=media&token=76422344-c1de-4415-a036-b7e62e8c06de";
          getAgentDealProperties[index] = {
            ...getAgentDealProperties[index],
            thumbnail,
          };
          setRequestingPropertiers(false);
        }
      }

      setAgentProperty([...getAgentDealProperties, ...agentProperties]);
      setRequestingPropertiers(false);
    }
    fetchData();
  }, [location.pathname, agentURLId]);
  // Agent Details useEffect End
  const navigate = useNavigate();
  // Agent Visits useEffect Start
  useEffect(() => {
    async function fetchData() {
      setRequestingAgents(true);
      const agentId = location.pathname.split("/").pop();
      let agentVisitsData = await AgentVisits(agentId);

      function extractLeads(arr, prop) {
        let extractedValue = arr.map((item) => item[prop]);
        return extractedValue;
      }
      // propertyId in visitors object
      let propertyID = Array.from(
        new Set(extractLeads(agentVisitsData, "propertyId"))
      ); // propertyId:xyz

      // fetch single property data / property object
      let propertyData = [];
      for (var i = 0; i < propertyID.length; i++) {
        propertyData.push(await GetProperty(propertyID[i]));
      }

      // replace property id with name from property data / property object
      agentVisitsData = agentVisitsData.map((visit) => {
        return {
          ...visit,
          propertyId: propertyData.filter(
            (property) => property.id === visit.propertyId
          )[0].propertyTitle,
        };
      });

      setAgentVisits(agentVisitsData);
      setRequestingAgents(false);
    }
    fetchData();
  }, [location.pathname, agentURLId]);
  // Agent Visits useEffect End

  /** Deals */
  const [Deals, setDeals] = useState([]);
  const [RequestingDeals, setRequestingDeals] = useState(true);
  const [refreshAgentDelete, setRefreshAgentDelete] = useState(false);
  const [selectedTab, setSelectedTab] = useState("Deals");
  useEffect(() => {
    async function fetchData() {
      setRequestingDeals(true);
      const agentId = location.pathname.split("/").pop();

      /** Get all agent deals */
      const deals = await GetAgentDealController(agentId);
      setDeals(deals);

      setRequestingDeals(false);
    }
    fetchData();
  }, [location.pathname, agentURLId]);

  // Invite Start
  const [InviteDialog, setInviteDialog] = useState(false);
  const [InviteAgentId, setInviteAgentId] = useState("");

  const handleOpenInviteDialog = (id) => {
    setInviteAgentId(id);
    setInviteDialog(true);
  };

  const handleCloseInviteDialog = (invite) => {
    setInviteDialog(false);
    if (invite === true) {
      handleAgentInvite(InviteAgentId);
      setInviteDialog(false);
    }
  };

  const handleAgentInvite = async (id) => {
    toast.info("Invite resend successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    await UpdateAgentEmailFlag(id);
  };
  // Invite End

  // Active Start
  const [ActiveDialog, setActiveDialog] = useState(false);
  const [ActiveAgentId, setActiveAgentId] = useState("");
  const handleOpenActveDialog = (id) => {
    setActiveAgentId(id);
    setActiveDialog(true);
  };
  const handleCloseActiveDialog = async (active) => {
    setActiveDialog(false);
    if (active === true) {
      await UpdateAgentStatusToInActive(ActiveAgentId);
      setRefreshAgentStatus(!refreshAgentStatus);
      setActiveDialog(false);
    }
  };
  // Active End

  // In Active Start
  const [InActiveDialog, setInActiveDialog] = useState(false);
  const [InActiveAgentId, setInActiveAgentId] = useState("");
  const handleOpenInActveDialog = (id) => {
    setInActiveAgentId(id);
    setInActiveDialog(true);
  };
  const handleCloseInActiveDialog = async (active) => {
    setInActiveDialog(false);
    if (active === true) {
      await UpdateAgentStatusToActive(InActiveAgentId);
      setRefreshAgentStatus(!refreshAgentStatus);
      setInActiveDialog(false);
    }
  };
  // In Active End

  // Delete Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [DeleteAgentId, setDeleteAgentId] = useState("");
  const handleOpenDeleteDialog = (id) => {
    setDeleteAgentId(id);
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      navigate("/user/agents");
      await DeleteAgent(DeleteAgentId);
      setRefreshAgentDelete(!refreshAgentDelete);
      setDeleteDialog(false);
    }
  };
  // Delete End
  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth <= 767) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <>
      <div className="global-body-container agent-details-page">
        <div className="d-flex align-items-start">
          <h2 className="custom-heading">Agent Details</h2>
        </div>
        <div className="agent-details-2-bar-2">
          <div className="agent-details-2">
            <div className="agent-details-2-image">
              {
                <Avatar
                  className="avatar-image"
                  {...stringAvatar(agentDetails?.name)}
                />
              }
            </div>
            <div className="agent-details-name-added">
              <h2 className="agent-details-name">{agentDetails?.name}</h2>
              <span className="agent-details-added">
                Added: {agentDetails?.createdAt.toDate().toLocaleDateString()}
              </span>
            </div>
          </div>
          <div className="agent-details-edit-delete-svg">
            {agentDetails?.status === "invite" &&
              agentDetails?.email !== "" && (
                <span
                  style={{ cursor: "pointer", marginLeft: "5px" }}
                  className="icon pr-1"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenInviteDialog(agentDetails?.id);
                  }}
                >
                  <img src={inviteIconWeb} alt="" width={35} height={35} />
                </span>
              )}
            {agentDetails?.status === "active" && (
              <span
                style={{ cursor: "pointer", marginLeft: "5px" }}
                className="icon"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenActveDialog(agentDetails?.id);
                }}
              >
                <img src={inActiveIconWeb} alt="" width={35} height={35} />
              </span>
            )}

            {agentDetails?.status === "inactive" && (
              <span
                style={{ cursor: "pointer", marginLeft: "5px" }}
                className="icon pr-1"
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenInActveDialog(agentDetails?.id);
                }}
              >
                <img src={activeIconWeb} alt="" width={35} height={35} />
              </span>
            )}
            <span
              style={{ cursor: "pointer", marginLeft: "5px" }}
              className="icon "
              onClick={(e) => {
                e.stopPropagation();
                handleOpenDeleteDialog(agentDetails?.id);
              }}
            >
              <img src={deleteIconWeb} alt="" width={35} height={35} />
            </span>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 mb-4">
            <ul className="agent-details-contact">
              {/* <!-- phone number  --> */}
              {agentDetails?.number && (
                <li>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#4C3CA6" />
                    <path
                      d="M6.22849 9.24169C7.23712 11.4385 9.03187 13.185 11.2632 14.1319L11.6209 14.2913C12.4392 14.6559 13.4012 14.3789 13.9003 13.6349L14.3677 12.9383C14.5197 12.7117 14.4734 12.4066 14.2611 12.2354L12.6759 10.9565C12.4431 10.7687 12.1007 10.8125 11.9226 11.0528L11.4322 11.7145C10.1739 11.0938 9.15229 10.0722 8.53159 8.81387L9.19329 8.32349C9.43366 8.14538 9.4774 7.803 9.28956 7.57017L8.01069 5.98494C7.83945 5.77268 7.53445 5.72638 7.30794 5.87826L6.60645 6.34863C5.85785 6.85058 5.58238 7.8205 5.9554 8.641L6.22808 9.2408L6.22849 9.24169Z"
                      fill="white"
                    />
                  </svg>

                  <span className="agent-details-contact-details">
                    {agentDetails?.number}
                  </span>
                </li>
              )}
              {/* <!-- end phone number  --> */}

              {/* <!-- email  --> */}
              {agentDetails?.email && (
                <li>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#4C3CA6" />
                    <path
                      d="M5.54988 8.0304C5.46478 7.98092 5.35621 8.03417 5.34629 8.13094C5.20786 9.48162 5.24136 10.8451 5.4468 12.1895C5.55511 12.8983 6.14294 13.4417 6.86854 13.5038L7.69251 13.5743C9.40273 13.7206 11.1226 13.7206 12.8329 13.5743L13.6569 13.5038C14.3824 13.4417 14.9703 12.8983 15.0786 12.1895C15.29 10.8059 15.3193 9.40211 15.1666 8.0129C15.1558 7.91544 15.0454 7.86317 14.9607 7.91476L11.8811 9.79088C10.8891 10.3952 9.63831 10.4078 8.63389 9.8238L5.54988 8.0304Z"
                      fill="white"
                    />
                    <path
                      d="M7.83735 5.35994C9.46705 5.23158 11.106 5.23158 12.7357 5.35994L13.5209 5.42179C14.0436 5.46296 14.4913 5.74545 14.7232 6.14954C14.7529 6.20123 14.7306 6.26382 14.676 6.29449L11.4183 8.1218C10.7196 8.51369 9.83858 8.52189 9.13115 8.14314L5.85168 6.38724C5.7987 6.35887 5.77438 6.30048 5.79826 6.24908C6.01046 5.79234 6.48754 5.46626 7.05217 5.42179L7.83735 5.35994Z"
                      fill="white"
                    />
                  </svg>
                  <span className="agent-details-contact-details">
                    {agentDetails?.email}
                  </span>
                </li>
              )}
              {/* <!-- end email  --> */}
              {agentDetails?.address && (
                <li>
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="10" cy="10" r="10" fill="#4C3CA6" />
                    <path
                      d="M11.4432 3.65884C10.7969 2.99133 9.72631 2.99133 9.07999 3.65883L5.92312 6.91919C5.74181 7.10643 5.61999 7.34315 5.57297 7.5995C5.18958 9.69029 5.16127 11.8307 5.48926 13.9309L5.60538 14.6744C5.64206 14.9093 5.84433 15.0825 6.08204 15.0825H8.28793C8.4696 15.0825 8.61688 14.9352 8.61688 14.7535V10.1483H11.9064V14.7535C11.9064 14.9352 12.0536 15.0825 12.2353 15.0825H14.4412C14.6789 15.0825 14.8812 14.9093 14.9178 14.6744L15.0339 13.9309C15.3619 11.8307 15.3336 9.69029 14.9503 7.5995C14.9032 7.34315 14.7814 7.10643 14.6001 6.91919L11.4432 3.65884Z"
                      fill="white"
                    />
                  </svg>
                  <span className="agent-details-contact-details">
                    {agentDetails?.address}
                  </span>
                </li>
              )}
            </ul>
            {isMobile && (
              <UserListCardDetail
                name={agentDetails?.name}
                date={agentDetails?.createdAt
                  ?.toDate()
                  ?.toLocaleString("en-GB", {
                    year: "numeric",
                    month: "short",
                    day: "numeric",
                  })}
                phone={agentDetails?.phone}
                email={agentDetails?.email}
                cnic={agentDetails?.cnic}
                address={agentDetails?.address}
                onDelete={() => {
                  handleOpenDeleteDialog(agentDetails?.id);
                }}
              />
            )}

            <div className="agent-details-buttons">
              <button
                type="button"
                onClick={() => {
                  setSelectedTab("Deals");
                }}
                className={` ${
                  selectedTab === "Deals"
                    ? " agent-detail-button agent-details-active "
                    : " agent-detail-button "
                }`}
              >
                Deals
              </button>

              <button
                type="button"
                onClick={() => {
                  setSelectedTab("Property Listing");
                }}
                className={` ${
                  selectedTab === "Property Listing"
                    ? " agent-detail-button agent-details-active  mr-2"
                    : " agent-detail-button mr-2"
                }`}
              >
                Property Listing
              </button>

              <button
                type="button"
                onClick={() => {
                  setSelectedTab("Visits");
                }}
                className={` ${
                  selectedTab === "Visits"
                    ? " agent-detail-button agent-details-active"
                    : " agent-detail-button"
                }`}
              >
                Visits
              </button>
            </div>
            <div className="agent-details-box">
              {selectedTab === "Deals" ? (
                <div className="agent-deals-container">
                  {Deals &&
                    Deals.map((dls) => {
                      const {
                        agent,
                        comments,
                        currentstatus,
                        interest,
                        client,
                        property,
                        createdAt,
                        transaction,
                        id,
                        dealPrice,
                      } = dls;
                      return (
                        <Link
                          to={`/user/deals/update/${id}`}
                          className="agent-deals-card-link"
                        >
                          <DealsCard
                            {...{
                              agent: agent.id,
                              comments: comments,
                              status: currentstatus,
                              interest: interest,
                              lead: client.id,
                              property: property.id,
                              createdAt: createdAt,
                              transaction: transaction,
                              dealPrice: dealPrice,
                              thumbnail: property.images
                                ? property.images[0]
                                : "https://firebasestorage.googleapis.com/v0/b/property-management-port-12157.appspot.com/o/general%2FloadingImg.gif?alt=media&token=5b6fb56c-aa61-4657-8f48-3a97b507f9c5",
                              CurrencySettings: CurrencySettings,
                            }}
                          />
                        </Link>
                      );
                    })}
                  {!isMobile && Deals.length === 0 ? (
                    <div className="agent-deals-no-data-found">
                      <NoDataFound />
                    </div>
                  ) : isMobile && Deals.length === 0 ? (
                    <div className="mobile-agent-deals-no-data-found">
                      <NoDataFound />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : selectedTab === "Property Listing" ? (
                <div className="row agent-properties-container">
                  {!RequestingPropertiers &&
                    agentProperty &&
                    agentProperty.map((property) => {
                      return (
                        <PropertiesContent
                          // id={property?.id}
                          // sellingPrice={property?.sellingPrice}
                          // rentalPrice={property?.rentalPrice}
                          // thumbnail={property?.thumbnail}
                          // studyroom={property?.studyroom}
                          // washroom={` ${property?.bathrooms}`}
                          // room={` ${property?.bedrooms}`}
                          // propertyTitle={property?.propertyTitle}
                          // CurrencySettings={CurrencySettings}
                          property={property}
                        />
                      );
                    })}
                  {RequestingPropertiers && <ContentLoader />}
                  {!RequestingPropertiers &&
                  !isMobile &&
                  agentProperty.length === 0 ? (
                    <div className="agent-property-no-data-found">
                      <NoDataFound />
                    </div>
                  ) : !RequestingPropertiers &&
                    isMobile &&
                    agentProperty.length === 0 ? (
                    <div className="mobile-agent-property-no-data-found">
                      <NoDataFound />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              ) : (
                selectedTab === "Visits" && (
                  <>
                    {!RequestingAgents && agentVisits?.length !== 0 && (
                      <div className="agent-visits-container">
                        {/* <div className="col-12"> */}
                        {!RequestingAgents &&
                          agentVisits?.map((visit) => {
                            return (
                              <SmallScreensLogVisitsComponent
                                ClientName={visit.client.name}
                                Status={visit.status}
                                Description={visit.comment}
                                DateTime={visit.visitTime}
                                DealID={visit.dealId}
                              />
                            );
                          })}
                        {/* </div> */}
                      </div>
                    )}
                    {!isMobile && agentVisits?.length === 0 ? (
                      <div className="agents-visit-no-data-found">
                        <NoDataFound />
                      </div>
                    ) : isMobile && agentVisits?.length === 0 ? (
                      <div className="mobile-agents-visit-no-data-found">
                        <NoDataFound />
                      </div>
                    ) : (
                      ""
                    )}
                  </>
                )
              )}
            </div>
          </div>
        </div>
      </div>

      <ConfirmationModal
        title={"Invite Again"}
        description={
          "This agent is aready invited. Would you like to invite the agent again?"
        }
        openDialog={InviteDialog}
        handleCloseDialog={handleCloseInviteDialog}
      />
      <ConfirmationModal
        title={"Active Status"}
        description={
          "Your agent is currently active. Would you like to make your agent inactive?"
        }
        openDialog={ActiveDialog}
        handleCloseDialog={handleCloseActiveDialog}
      />
      <ConfirmationModal
        title={"In Active Status"}
        description={
          "Your agent is currently inactive. Would you like to make your agent active?"
        }
        openDialog={InActiveDialog}
        handleCloseDialog={handleCloseInActiveDialog}
      />
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this agent?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </>
  );
};

export default AgentsDetails;
